
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free_books",
      function () {
        return require("private-next-pages/free_books/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free_books"])
      });
    }
  